// utils/MUX/ApiHelper.js
import muxApi from "./api";

class MuxApiHelper {
  constructor() {
    // Bind methods for Redux Saga compatibility
    this.createDirectUpload = this.createDirectUpload.bind(this);
    this.getUploadStatus = this.getUploadStatus.bind(this);
    this.getAsset = this.getAsset.bind(this);
    this.deleteAsset = this.deleteAsset.bind(this);
    this.uploadToMux = this.uploadToMux.bind(this);
  }

  /**
   * Create a direct upload URL
   * @param {Object} options - Upload options
   * @returns {Promise}
   */
 async createDirectUpload(options = {}) {
    try {
      const response = await fetch('/api/mux/create-upload', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(options),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to create upload');
      }

      return data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Get upload status
   * @param {string} uploadId - Mux upload ID
   * @returns {Promise}
   */
 async getUploadStatus(uploadId) {
    try {
      const response = await fetch(`/api/mux/upload-status/${uploadId}`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to get upload status');
      }

      return data;
    } catch (error) {
      return this.handleError(error);
    }
  }


  /**
   * Get asset details
   * @param {string} assetId - Mux asset ID
   * @returns {Promise}
   */
  async getAsset(assetId) {
    try {
      const response = await fetch(`/api/mux/asset/${assetId}`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to get asset');
      }

      return data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Delete an asset
   * @param {string} assetId - Mux asset ID
   * @returns {Promise}
   */
  async deleteAsset(assetId) {
    try {
      const response = await fetch(`/api/mux/asset/${assetId}`, {
        method: 'DELETE',
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to delete asset');
      }

      return data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Upload file directly to Mux
   * @param {File} file - Video file
   * @param {string} uploadUrl - Mux upload URL
   * @param {Function} onProgress - Progress callback
   * @returns {Promise}
   */
  async uploadToMux(file, uploadUrl, onProgress = null) {
    console.log("Uploading to Mux URL:", uploadUrl);
    try {
      const response = await fetch(uploadUrl, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type || 'video/mp4',
        },
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.statusText}`);
      }

      return {
        success: true,
        message: 'Upload completed successfully',
      };
    } catch (error) {
      return this.handleError(error);
    }
  }

  // async checkUploadStatus(uploadId) {
  //   try {
  //     const response = await muxApi.get(`/video/v1/uploads/${uploadId}`);
  //     return {
  //       success: true,
  //       data: response.data,
  //     };
  //   } catch (error) {
  //     return this.handleError(error);
  //   }
  // }

  /**
   * Handle errors
   * @param {Object} error - Error object
   * @returns {Object}
   */
  handleError(error) {
    const errorResponse = {
      success: false,
      message: error.response?.data?.error?.messages?.[0] || error.message || 'Mux API error',
      error: error.response?.data?.error || null,
      status: error.response?.status || 500,
    };

    if (process.env.NODE_ENV === 'development') {
      console.error('Mux API Error:', errorResponse);
    }

    return errorResponse;
  }
}

export default new MuxApiHelper();